import { QuestionnaireStatus } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const submitQuestionnaire: (
  fetchContext: FetchContext,
  questionnaireId: number,
  accessToken?: string,
) => Promise<void> = (fetchContext, questionnaireId, accessToken) => {

  const submittedStatus: QuestionnaireStatus = {
    questionnaireId,
    status: 'Submitted',
  };

  return fetch(`${fetchContext.baseUrl}/api/questionnaires/${questionnaireId}/status`, {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(submittedStatus),
  }).then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'submit questionnaire'));
};
